import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { CAMPAIGNS } from '../constants'
import { CampaignFormInput } from '../types'
import { transformCampaignInput } from '../utils'

const createCampaign = async (form: CampaignFormInput) => {
  const data = transformCampaignInput(form)

  await fetchAPI({
    method: 'post',
    path: '/campaigns',
    data,
  })
}

export const useCreateCampaign = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(createCampaign, {
    onSuccess: async () => {
      await queryClient.refetchQueries([CAMPAIGNS])

      toast({
        description: t('views.admin.campaigns.services.create_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
